export default ".value-item {\n  padding: 0;\n  padding-left: 12px;\n}\n.value-item mdc-text-field {\n  border-radius: 0;\n  border: 0;\n}"